export const FETCH_GET_PARTICULAR_USER_INFO_REQUEST = 'FETCH_GET_PARTICULAR_USER_INFO_REQUEST'
export const FETCH_GET_PARTICULAR_USER_INFO_SUCCESS = 'FETCH_GET_PARTICULAR_USER_INFO_SUCCESS'
export const FETCH_GET_PARTICULAR_USER_INFO_FALUIRE = 'FETCH_GET_PARTICULAR_USER_INFO_FALUIRE'
